import { JobStatus } from '@applicator/shared'

// Pipeline statuses (in order)
export const pipelineStatuses: JobStatus[] = [
  'Bookmarked',
  'Applying',
  'Applied',
  'Interviewing',
  'Negotiating',
  'Accepted',
]

// Close job statuses (for dropdown)
export const closeJobStatuses: JobStatus[] = [
  'I Withdrew',
  'Not Selected',
  'No Response',
  'Archived',
]
